import { AppDispatch } from 'App';
import { setPaginationByTypeAction } from 'store/actions/listsActions';
import { getSettingsByKeyAction } from 'store/actions/settingsActions';
import { ESettingsKey } from 'store/reducers/settingsReducer/settingsTypes';
import sendNotification, { ENotificationTypes } from 'utils/sendNotification';
import { isProdEnv } from 'utils/constants/constants';
import { EListsTypes } from 'types/listsTypes';

export const pusherConnectedAction = () => () =>
  !isProdEnv && window.console.log('%cPUSHER: Connected', 'color: #59ce88');

export const pusherErrorAction = (data: any) => !isProdEnv && window.console.error('PUSHER: Error', data);

export const pusherDisconnectedAction = () => () =>
  !isProdEnv && window.console.log('%cPUSHER: Disconnected', 'color: #eb4242');

interface IPusherProductSyncActionProps {
  products_sync_count: number,
  error_message?: string,
}

export const pusherProductSyncAction = ({ products_sync_count, error_message }: IPusherProductSyncActionProps) =>
  (dispatch: AppDispatch) => {
    if (error_message) {
      sendNotification(ENotificationTypes.Error, error_message);
    } else {
      dispatch(setPaginationByTypeAction({
        listType: EListsTypes.ProductsType, pagination: { syncStatus: 'finished' },
      }));
      sendNotification(ENotificationTypes.Success, `${products_sync_count} products successfully synchronized`);
      dispatch(getSettingsByKeyAction(ESettingsKey.StoreSettings));
    }
  };
